import { useState } from "react";
import { treeHoles } from "@/mocks/home";

export default function TreeHoleSection() {
  const [liked, setLiked] = useState<number[]>([]);

  const toggle = (id: number) =>
    setLiked((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));

  return (
    <section id="treehole" className="relative overflow-hidden py-16 md:py-20">
      <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-accent-200/40 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-24 bottom-10 h-72 w-72 rounded-full bg-primary-200/40 blur-3xl"></div>

      <div className="container-site relative">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-primary-600">
              Tree Hole
            </span>
            <h2 className="mt-2 text-2xl font-black text-foreground-950 md:text-4xl">
              深夜树洞 · 想说就说
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              追剧的空落、路透的期待、职场的心事……树洞匿名收下你的每句话。给有共鸣的留言点个赞，让陌生人的安慰不缺席。
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-background-100 px-3 py-1.5 text-xs font-semibold text-foreground-700">
            <i className="ri-moon-clear-line text-accent-600"></i> 今晚已有 2.4w 条悄悄话
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
          {treeHoles.map((t) => {
            const isLiked = liked.includes(t.id);
            return (
              <article
                key={t.id}
                className="flex flex-col rounded-xl border border-background-200/70 bg-background-100/70 p-5"
              >
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-100 text-lg">
                    {t.emoji}
                  </span>
                  <div>
                    <p className="text-xs font-bold text-foreground-800">匿名瓜友</p>
                    <p className="text-[11px] text-foreground-500">{t.time}</p>
                  </div>
                  <span className="ml-auto rounded-full bg-background-200 px-2.5 py-1 text-[10px] font-semibold text-foreground-700">
                    <i className="ri-lock-2-line mr-1 align-middle"></i>匿名发布
                  </span>
                </div>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-800">{t.text}</p>
                <div className="mt-4 flex items-center gap-4 text-xs text-foreground-600">
                  <button
                    onClick={() => toggle(t.id)}
                    aria-pressed={isLiked}
                    className={`inline-flex items-center gap-1 transition ${
                      isLiked ? "text-primary-600" : "hover:text-primary-600"
                    }`}
                  >
                    <i className={isLiked ? "ri-heart-3-fill text-lg" : "ri-heart-3-line text-lg"}></i>
                    {isLiked ? Number(t.likes.replace("k", "000")).toLocaleString() : t.likes}
                  </button>
                  <span><i className="ri-chat-1-line mr-1 align-middle text-lg"></i>{t.replies} 回复</span>
                  <span className="ml-auto text-primary-600"><i className="ri-chat-smile-2-line text-lg"></i></span>
                </div>
              </article>
            );
          })}
        </div>

        <div className="mt-6 rounded-xl border border-dashed border-primary-300 bg-primary-100/50 p-5 text-center">
          <p className="text-sm text-primary-900">
            心里话憋着难受？现在就想找人聊聊——这里永远为你留一盏灯。
          </p>
          <a
            href="#faq"
            className="mt-3 inline-flex items-center gap-1 rounded-md bg-primary-500 px-6 py-2.5 text-sm font-bold text-background-50 transition hover:bg-primary-600"
          >
            我想倾诉 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}